module.exports = __webpack_public_path__ + "static/media/11.f0ba2d72.jpg";